module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside",
    staticStyle: {
      "display": "block",
      "padding": "0.5rem 1rem"
    }
  }, [_c('ScanBarcode', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    on: {
      "setBarcode": _vm.getBarcode
    }
  }), _c('div', {
    staticStyle: {
      "display": "block",
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "20px",
      "white-space": "nowrap",
      "display": "inline-block"
    }
  }, [_vm._v("1. 請輸入病歷號(或直接掃描 QR Code帶入先前排程): ")]), (_vm.manualInputMedRecordId == true) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medRecordId),
      expression: "medRecordId"
    }],
    ref: "medInput",
    staticClass: "form-control-sm form-control",
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    domProps: {
      "value": (_vm.medRecordId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medRecordId = $event.target.value
      }
    }
  })]) : _vm._e(), (_vm.manualInputMedRecordId == false) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medRecordId),
      expression: "medRecordId"
    }],
    ref: "medInput",
    staticClass: "form-control-sm form-control",
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.medRecordId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medRecordId = $event.target.value
      }
    }
  })]) : _vm._e()]), _c('div', [_c('p', [_vm._v("2. 選擇類別: "), (_vm.selectedSet) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.selectedSet))]) : _vm._e()]), (_vm.selectedSet === undefined) ? _c('div', {
    staticClass: "button-wrapper"
  }, _vm._l((_vm.combos), function(set, set_ind) {
    return _c('div', {
      staticClass: "control-button-custom control-button control-button-green m-1",
      staticStyle: {
        "width": "120px"
      },
      on: {
        "click": function($event) {
          _vm.selectedSet = set.dep_name
        }
      }
    }, [_c('div', {
      staticClass: "button-inside-wrap"
    }, [_vm._v(_vm._s(set.dep_name))])])
  }), 0) : _vm._e(), _c('p', [_vm._v("3. 選擇套藥")]), (_vm.selectedSet !== undefined) ? _c('div', {
    staticClass: "button-wrapper"
  }, _vm._l((_vm.combosets[_vm.selectedSet].combolist), function(combo, combo_ind) {
    return _c('div', {
      staticClass: "control-button-custom control-button control-button-green m-1",
      class: {
        'control-button-selected': combo.selected
      },
      on: {
        "click": function($event) {
          return _vm.setCombo(combo, combo_ind)
        }
      }
    }, [_c('div', {
      staticClass: "button-inside-wrap"
    }, [_vm._v(_vm._s(combo.generic_name))])])
  }), 0) : _vm._e()]), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "500px",
      "bottom": "-97px"
    }
  }, [_c('button', {
    staticClass: "btn control-button control-button-red",
    on: {
      "click": _vm.gotoFetchDrugGroup
    }
  }, [_vm._v("類別取藥")])]), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "bottom": "-97px"
    }
  }, [_c('button', {
    staticClass: "btn control-button control-button-red",
    on: {
      "click": _vm.startAction
    }
  }, [_vm._v("下一步驟")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60be0957","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/CreateSchedule.vue
// module id = 1489
// module chunks = 1